import { motion } from "framer-motion";
import {
  Layers, Users, ShieldCheck, ScrollText, Plug, Boxes, Bot, LineChart,
  Database, Smartphone, Cloud, FileBarChart, Bell, Mail, FileText, Workflow,
} from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { HOME_I18N } from "../i18n/home";

const ICONS = [
  Layers, Users, ShieldCheck, ScrollText, Plug, Boxes, Bot, LineChart,
  Database, Smartphone, Cloud, FileBarChart, Bell, Mail, FileText, Workflow,
];

export default function ScaleCapability() {
  const { lang } = useLang();
  const t = HOME_I18N[lang].scale;

  return (
    <section className="section relative overflow-hidden bg-[#07111F] text-white" data-testid="scale-section">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-grid opacity-30" />
        <div className="absolute -top-24 left-1/3 h-[380px] w-[380px] rounded-full bg-[#2563EB]/20 blur-[130px]" />
        <div className="absolute bottom-0 right-1/4 h-[340px] w-[340px] rounded-full bg-[#22D3EE]/15 blur-[130px]" />
      </div>

      <div className="container-x relative">
        <div className="max-w-3xl">
          <span className="eyebrow-light">{t.eyebrow}</span>
          <h2 className="mt-3 font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white">
            {t.title1}<br />
            <span className="text-gradient">{t.titleAccent}</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-white/70 max-w-2xl">{t.desc}</p>
        </div>

        <div className="mt-14 grid gap-3 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
          {t.items.map((label, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={label}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.35, delay: (i % 4) * 0.04 }}
                className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.03] p-4 backdrop-blur transition hover:border-[#22D3EE]/30 hover:bg-white/[0.06]"
                data-testid={`capability-${i}`}
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-[#2563EB]/30 to-[#22D3EE]/25 border border-white/10">
                  <Icon className="h-4 w-4 text-[#22D3EE]" strokeWidth={1.8} />
                </span>
                <span className="text-sm font-medium text-white/85 leading-snug">{label}</span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
